export default {
  'financeReconciliation.pageTitle': '财务对账',
  'financeReconciliation.pageSubTitle': '默认上传了银行账单附件的记录为已结算',
  'financeReconciliation.emptyHint': '请选择银行账户和账期，查看对账明细',
  'financeReconciliation.bankAccount': '银行账户',
  'financeReconciliation.accountPeriod': '账期',
  'financeReconciliation.statementNo': '账单号',
  'financeReconciliation.currency': '币种',
  'financeReconciliation.filterTitle': '筛选条件',
  'financeReconciliation.transactionList': '交易流水',
  'financeReconciliation.clearImportedData': '清空数据',
  'financeReconciliation.clearImportedDataModalTitle': '清空导入数据',
  'financeReconciliation.clearImportedDataModalContent':
    '确认清空该账期下所有已导入的银行流水数据及其关联记账？此操作不可恢复。',
  'financeReconciliation.clearImportedDataSuccess': '已清空导入数据',
  'financeReconciliation.clearImportedDataFailed': '清空导入数据失败',
  'financeReconciliation.exportStatement': '导出账单',
  'financeReconciliation.monthlyStatement': '月度对账单',
  'financeReconciliation.statementPeriod': '账单周期',
  'financeReconciliation.opening': '期初余额',
  'financeReconciliation.credit': '本期收入',
  'financeReconciliation.debit': '本期支出',
  'financeReconciliation.closing': '期末余额',
  'financeReconciliation.transactionDate': '交易日期',
  'financeReconciliation.matchStatus': '对账匹配状态',
  'financeReconciliation.description': '摘要/对方户名',
  'financeReconciliation.transferRemark': '转账备注',
  'financeReconciliation.bankRemark': '银行备注',
  'financeReconciliation.amount': '金额',
  'financeReconciliation.diffAmount': '差额',
  'financeReconciliation.debitOut': '支出 (OUT)',
  'financeReconciliation.creditIn': '收入 (IN)',
  'financeReconciliation.balance': '余额 (BAL)',
  'financeReconciliation.totalSummary': 'TOTAL SUMMARY',
  'financeReconciliation.pageSummary': '本期核对汇总',
  'financeReconciliation.selectBankAccount': '请选择银行账户',
  'financeReconciliation.selectAccountPeriod': '请选择账期',
  'financeReconciliation.includeUnsettled': '包含未结算',
  'financeReconciliation.createDetail': '新建明细',
  'financeReconciliation.settleStatement': '账单结算',
  'financeReconciliation.importStatement': '账单导入',
  'financeReconciliation.import.bankNameLabel': '银行模板类型',
  'financeReconciliation.import.selectBankName': '请选择银行模板类型',
  'financeReconciliation.import.uploadHint': '点击或拖拽 Excel 文件到此处上传',
  'financeReconciliation.import.uploadFormat': '支持 .xlsx、.xls 格式',
  'financeReconciliation.import.uploading': '正在导入账单...',
  'financeReconciliation.import.success': '账单导入成功',
  'financeReconciliation.import.failed': '账单导入失败',
  'financeReconciliation.import.loadBankFailed': '加载银行模板类型失败',
  'financeReconciliation.import.missingStatement': '请先选择账期',
  'financeReconciliation.searchPlaceholder': '搜索流水摘要或关联凭证',
  'financeReconciliation.refresh': '刷新',
  'financeReconciliation.unsettledBadge': '未结算',
  'financeReconciliation.filter.all': '全部',
  'financeReconciliation.filter.skipped': '无需对账',
  'financeReconciliation.matchStatus.pending': '待匹配',
  'financeReconciliation.matchStatus.matched': '已匹配',
  'financeReconciliation.matchStatus.unknown': '未知',
  'financeReconciliation.matchStatus.partialMatch': '部分匹配',
  'financeReconciliation.status.settled': '已结算',
  'financeReconciliation.status.unsettled': '未结算',
  'financeReconciliation.match.drawerTitle': '流水手动匹配',
  'financeReconciliation.match.bankInfo': '银行账户信息',
  'financeReconciliation.match.transactionInfo': '当前流水',
  'financeReconciliation.match.filterTitle': '匹配筛选',
  'financeReconciliation.match.candidateList': '待匹配记录',
  'financeReconciliation.match.candidateCount': '共 {count} 条',
  'financeReconciliation.match.noCandidates': '暂无符合条件的记录',
  'financeReconciliation.match.amountType': '收支方向',
  'financeReconciliation.match.confirm': '确认匹配',
  'financeReconciliation.match.success': '匹配成功',
  'financeReconciliation.match.failed': '匹配失败',
  'financeReconciliation.match.loadExpenseFailed': '加载待匹配记录失败',
  'financeReconciliation.match.selectExpenseRequired': '请选择要匹配的费用记录',
  'financeReconciliation.match.manualBadge': '手动对账',
  'financeReconciliation.match.transactionAmount': '交易金额 ({currency})',
  'financeReconciliation.match.remarkPrefix': '备注',
  'financeReconciliation.match.searchKeyword': '关键词搜索',
  'financeReconciliation.match.searchPlaceholder': '搜索编号、明细或金额...',
  'financeReconciliation.match.houseSelectPlaceholder': '请选择房屋信息',
  'financeReconciliation.match.parkingSelectPlaceholder': '请选择车位信息',
  'financeReconciliation.match.dateRange': '时间范围',
  'financeReconciliation.match.resetFilters': '重置当前筛选',
  'financeReconciliation.match.selectHint': '请勾选下方本地单据进行对账',
  'financeReconciliation.match.targetAmount': '目标流水金额: {amount}',
  'financeReconciliation.match.perfectMatch': '金额完全吻合！',
  'financeReconciliation.match.amountSummary':
    '目标: {target} | 选中: {selected}',
  'financeReconciliation.match.finalAmountSummary':
    '应还款: {target} | 历史已匹配: {previous} | 本次: {selected} | 最终: {final}',
  'financeReconciliation.match.perfectBadge': '完美匹配',
  'financeReconciliation.match.amountMismatch': '匹配差额不匹配',
  'financeReconciliation.match.shortBy': '还差 {amount}',
  'financeReconciliation.match.overBy': '超额 {amount}',
  'financeReconciliation.match.filteredCount': '(当前筛选下有 {count} 条)',
  'financeReconciliation.match.expenseDetailSuffix': '费用明细数据',
  'financeReconciliation.match.mortgageRepaymentSuffix': '(房贷还款)',
  'financeReconciliation.match.carRepaymentSuffix': '(车贷还款)',
  'financeReconciliation.match.autoRecommend': '智能查找等额',
  'financeReconciliation.match.autoRecommendSuccess':
    '已为您推荐金额吻合的单据',
  'financeReconciliation.match.autoRecommendFailed':
    '未找到金额完全吻合的单据，请手动选择',
  'financeReconciliation.match.selectionSummary':
    '当前选中了 1 笔单据，金额 {amount}',
  'financeReconciliation.match.pendingPageSummary':
    '当前页共 {count} 条，合计金额 {amount}',
  'financeReconciliation.match.noSelection': '尚未选择任何单据',
  'financeReconciliation.match.footerHint': '金额完全吻合时可直接确认匹配入账',
  'financeReconciliation.match.clearSelection': '取消勾选',
  'financeReconciliation.match.markUnknown': '未知流水',
  'financeReconciliation.match.markUnknownSuccess': '已标记为未知流水',
  'financeReconciliation.match.markUnknownFailed': '标记未知流水失败',
  'financeReconciliation.match.markUnknownModalTitle': '标记未知流水',
  'financeReconciliation.match.markUnknownModalContent':
    '确认将该流水标记为未知？标记后将不再参与本次对账匹配。',
  'financeReconciliation.match.confirmModalTitle': '确认匹配',
  'financeReconciliation.match.confirmModalPerfectDesc':
    '实际还款金额与应还款金额完全吻合',
  'financeReconciliation.match.confirmModalPerfectQuestion': '确认匹配入账？',
  'financeReconciliation.match.confirmModalForceDesc':
    '实际还款金额与应还款金额不一致',
  'financeReconciliation.match.confirmModalForceQuestion': '是否确认强制匹配？',
  'financeReconciliation.match.confirmModalStatusLabel': '匹配状态',
  'financeReconciliation.match.confirmModalStatusMatchedDesc':
    '单据已完整对上，标记为已匹配',
  'financeReconciliation.match.confirmModalStatusPartialDesc':
    '金额尚未完全对上，标记为部分匹配',
  'financeReconciliation.match.confirmModalTransactionAmount': '流水金额',
  'financeReconciliation.match.confirmModalRecordAmount': '单据金额',
  'financeReconciliation.match.confirmModalShortfall': '还差',
  'financeReconciliation.match.confirmModalOverage': '超额',
  'financeReconciliation.match.remarksLabel': '备注',
  'financeReconciliation.match.remarksPlaceholder': '点击添加备注',
  'financeReconciliation.match.remarksModalTitle': '编辑备注',
  'financeReconciliation.match.remarksInputPlaceholder': '请输入备注信息',
  'financeReconciliation.match.remarksUpdateSuccess': '备注已更新',
  'financeReconciliation.match.remarksUpdateFailed': '备注更新失败',
  'financeReconciliation.match.categoryLabel': '银行账单匹配分类',
  'financeReconciliation.match.category.dailyExpense': '综合流水关联',
  'financeReconciliation.match.category.realEstate': '还款房贷关联',
  'financeReconciliation.match.category.propertyFee': '物业费关联',
  'financeReconciliation.match.alreadyMatched': '该记录已匹配银行流水，不可再次添加匹配',
  'financeReconciliation.match.dueAmount': '应还款金额',
  'financeReconciliation.match.actualAmount': '实际还款金额',
  'financeReconciliation.match.previousMatchedAmount': '历史已匹配金额',
  'financeReconciliation.match.finalAmount': '最终累计金额',
  'financeReconciliation.match.finalAmountPending': '最终金额（待核对）',
};
